import React from 'react'
import GeneralServices from '../../app/service/generalServices'
import { Dialog } from 'primereact/dialog'

class DadosDevolucaoComponent extends React.Component {

    constructor(){
        super()
    }

    state = {

    }

    montaFraseDadosDevolucao = (notaFiscalDevolucaoReferencia) => {
        // console.log("montaFraseDadosDevolucao: ", notaFiscalDevolucaoReferencia)
        let nfDevolvida = notaFiscalDevolucaoReferencia.nfDevolvida
        if(nfDevolvida){
            return `N° ${nfDevolvida.numero}, chave ${nfDevolvida.chave}, Valor Total: ${GeneralServices.valueBodyTemplateWithCifrao(nfDevolvida.valorTotal)}.`
        }
        return ""
    }    

    render(){

        const renderDevolucaoInfoList = () => {
            let componentList = []
            this.props.notaFiscalDevolucaoReferenciaResponse.list.forEach(notaFiscalDevolucaoReferencia => {
                componentList.push(renderDevolucaoInfo(notaFiscalDevolucaoReferencia))
            })
            return componentList;
        }

        const renderDevolucaoInfo = (notaFiscalDevolucaoReferencia) => {
            return (
                <div>
                    <li>
                        <strong>Nota Fiscal Devolvida: </strong>
                        {this.montaFraseDadosDevolucao(notaFiscalDevolucaoReferencia)}
                    </li>

                    <li>
                        <strong>Nota Fiscal de Devolução: </strong>
                        {`N° ${notaFiscalDevolucaoReferencia.nfDevolucao.numero}, chave ${notaFiscalDevolucaoReferencia.nfDevolucao.chave}, Valor Total: ${GeneralServices.valueBodyTemplateWithCifrao(notaFiscalDevolucaoReferencia.nfDevolucao.valorTotal)}.`}
                    </li>
                    
                    <li>
                        <strong>Informação Complementar: </strong>
                        {notaFiscalDevolucaoReferencia.nfDevolucao.informacaoComplementar}
                    </li>

                    <br />
                </div>
            )
        }

        const trataRender = () => {
            
            if(!this.props.notaFiscalDevolucaoReferenciaResponse){
                return (<></>)
            }

            return (
                <Dialog
                    header={"Dados da Devolução"}
                    visible={this.props.visible}
                    modal
                    style={{ width: '70vw' }}
                    onHide={this.props.hideNFDevolucaoEntradaDialog}
                >

                    <div
                        className="confirmation-content"
                        style={{marginLeft: '20px'}}
                    >

                        {renderDevolucaoInfoList()}

                        <li>
                            <strong>Tipo de Devolução: </strong>
                            {this.props.notaFiscalDevolucaoReferenciaResponse.tipoDevolucao}
                        </li>
                    </div>
        
                </Dialog>
            )
        }

        return (
            <>
                {trataRender()}
            </>
        )
    }


}

export default DadosDevolucaoComponent